<header class="site-header side-padding">
  <naas-header></naas-header>
</header>
<main id="main_naas_content">
  <article class="loading" *ngIf="loading" aria-label="page loading spinner">
    <div class="mat-spinner" title="angular_placeholder_mat-spinner"></div>
  </article>
  <router-outlet *ngIf="!loading" title="routing tag"></router-outlet>
</main>
<footer class="side-padding">
  <naas-footer></naas-footer>
</footer>
